import * as constants from '../constants/aoi';

const initialState = {
    aois: []
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.SET_AOIS:
            return {
                ...state,
                aois: action.aois
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/aoi.js